<template>
  <div class="lisa-configurator h-screen flex justify-between" :class="initialized ? '' : 'is-loading'" >
    <drawer v-if="!isMobile"></drawer>
    <drawer-mobile v-else></drawer-mobile>
    <viewport></viewport>
    <!--todo devo passare come proprietà titolo, id, e altri parametri del moodboard-->
    <sidebar v-if="!isMobile"></sidebar>

  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { isMobile } from 'mobile-device-detect'
  // @ is an alias to /src
  import Drawer from '../components/Drawer'
  import DrawerMobile from '../components/DrawerMobile'
  import Sidebar from '../components/Sidebar'
  import Viewport from '../components/Viewport'

  export default {
    name: 'Home',
    components: {
      Drawer,
      Sidebar,
      Viewport,
      DrawerMobile
    },
    data() {
      return {
        clientX: 0,
        clientY: 0,
        loaded: 0,
        toLoad: 0,
        isMobile: isMobile,
      }
    },
    computed: {
      ...mapGetters([
        'initialized'
      ]),
    },
    methods: {
      ...mapActions([
        'setTitle',
      ])
    },
    mounted() {
      if(window.front_ajax_obj && window.front_ajax_obj.post_title) {

        this.setTitle(window.front_ajax_obj.post_title);

      }
    }
  }
</script>

<style scoped>
  .lisa-configurator {
    padding: 210px 85px 0px 314px;
    background-image: url("/img/sidebar-menu-demo.jpg");
    background-size: 1920px;
    background-position: top left;
    background-repeat: no-repeat;
    position: relative;
    transition: all 0.5s ease-in-out;
  }

  .lisa-configurator.is-loading {
    opacity: 0.5;
    pointer-events: none;
  }

  .lisa-configurator::before {
    content: '';
    display: block;
    position: absolute;
    right: 0;
    top: 0;
    max-height: 210px;
    height: 100%;
    width: 50vw;
    background-image: url("/img/top-right-menu-demo.png");
    background-size: 1920px;
    background-position: top right;
    background-repeat: no-repeat;
    z-index: 999;
  }

  .slider {
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
  }


  @media only screen and (max-width: 1024px) {

    .lisa-configurator {
      padding: 0px;
      background-image: unset;
      background-size: unset;
      background-position: unset;
      background-repeat: unset;
    }

    .lisa-configurator::before {
      display: none;
    }

  }
</style>
